import { ViewModel, View, ObservableArray, ViewModelMessage } from "binder"
import { ExportViewModel } from "src/bpms/rawData/processDefinition/processForms/export/export-viewModel";
import { ImportViewModel } from "src/bpms/rawData/processDefinition/processForms/import/import-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ButtonComponent } from "src/formBuilder/components/button/button-viewModel";
import { CheckBoxComponent } from "src/formBuilder/components/checkbox/checkbox-viewModel";
import { ClientFilterTableComponent } from "src/formBuilder/components/clientFilterTable/clientFilterTable-viewModel";
import { ServerFilterTableComponent } from "src/formBuilder/components/clientFilterTable/serverFilteringTable-viewModel";
import { ComboComponent } from "src/formBuilder/components/combo/combo-viewModel";
import { ContentComponent } from "src/formBuilder/components/content/content-viewModel";
import { DateSelectorComponent } from "src/formBuilder/components/date/data-viewModel";
import { DummyPlaceHolderComponent, DummyPlaceHolderElement } from "src/formBuilder/components/dummyPlaceHolder/dummyPlaceHolder-viewModel";
import { DummyTablePlaceHolderComponent } from "src/formBuilder/components/dummyPlaceHolder/dummyTablePlaceHolderComponent/dummyTablePlaceHolderComponent-viewModel";
import { TdComponent } from "src/formBuilder/components/dummyPlaceHolder/dummyTablePlaceHolderComponent/td/td-viewModel";
import { GridComponent } from "src/formBuilder/components/grid/grid-viewModel";
import { HrComponent } from "src/formBuilder/components/hr/hr-viewModel";
import { InputComponent } from "src/formBuilder/components/input/input-viewModel";
import { ListComponent } from "src/formBuilder/components/list/list-viewModel";
import { LoadingComponent } from "src/formBuilder/components/loading/loading-viewModel";
import { MultiLineInputComponent } from "src/formBuilder/components/multiLineInput/multiLineInput-viewModel";
import { ScrollComponent } from "src/formBuilder/components/scroll/scroll-viewModel";
import { SpanComponent } from "src/formBuilder/components/span/span-viewModel";
import { CompiledClass } from "src/formBuilder/datamodel/classGenerator";
import { DataModel, DataModelClass } from "src/formBuilder/datamodel/structure";
import { customDeserializer, customSerializer } from "src/formBuilder/serialization/customSerializer";
import { HtmlSerializer } from "src/formBuilder/serialization/htmlSerializer";
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement } from "src/formBuilder/structure/element";
import { FormBuilderElementSelectedMessage, FormBuilderElementUnSelectMessage } from "src/formBuilder/structure/elementDecorators/componentSelectDecorator/componentSelectDecorator-viewModel";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { GetAllTemplateMessage } from "../formBuilder/formBuilder-viewModel";
import { MediaTypes, TemplateViewModel } from "../templateList/templateList-viewModel";
import { PropertiesPanelViewModel } from "./propertiesPanel/propertiesPanel-viewModel";
import { TemplateEditorView } from "./templateEditor-view"
import { FilesListComponent } from "src/formBuilder/components/filesList/filesList-viewModel";
import { UnsavedChangesAreCreatedMessage } from "src/bpms/rawData/processDefinition/processForms/processForms-viewModel";
import { PreviewFormBuilderFormMessage } from "../formBuilderWindow-viewModel";
import { ImageComponent } from "src/formBuilder/components/image/image-viewModel";
import { IconComponent } from "src/formBuilder/components/icon/icon-viewModel";
import { ExpanderComponent } from "src/formBuilder/components/expander/expander-viewModel";
import { BarcodeReaderComponent } from "src/formBuilder/components/barcodeReader/barcodeReader-viewModel";
import { ChartComponent } from "src/formBuilder/components/chart/chart-viewModel";
import { GuageComponent } from "src/formBuilder/components/guage/guage-viewModel";

export class TemplateEditorViewModel extends ViewModel implements ITemplateSelector {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.structureEditor = new structureEditor(this);
        this.componentsList = new ComponentsList(this);
        this.propertiesPanel = new PropertiesPanelViewModel(this);
        this._Builder_TemplateSelector__ = this;
        this.currentPart = this.componentsList;
        this.contentDirection = (<HTMLElement>document.body.children.namedItem("mainPageDiv")).dir;
    }
    getTemplate(vm: ViewModel, selector: string) {
        let templates = this.handleMessage(new GetAllTemplateMessage());
        let functionProto = Function(`a=function(vm){${selector}};return a;`);
        let executableFunction = functionProto();
        let name = executableFunction(vm);
        let found = (<TemplateViewModel[]>templates).filter(x => x.name == name);
        if (found.length == 0)
            return null;
        let foundTemplate = found[0];
        return foundTemplate.templateNode;

    }
    GetDefaultView(): View<ViewModel> {
        return new TemplateEditorView();
    }
    public getTypeId(): string {
        return "VM-A27788EA-B20B-4F1D-B69E-8F03A2A301E5"
    }

    public set componentsList(v: ComponentsList) { this._componentsList = v; } public get componentsList(): ComponentsList { return this._componentsList; } private _componentsList: ComponentsList;
    public set propertiesPanel(v: PropertiesPanelViewModel) { this._propertiesPanel = v; } public get propertiesPanel(): PropertiesPanelViewModel { return this._propertiesPanel; } private _propertiesPanel: PropertiesPanelViewModel;
    public set contentDirection(v: string) { this._contentDirection = v; } public get contentDirection(): string { return this._contentDirection;} private _contentDirection: string;
    

    public set rootElement(v: FormBuilderElement) {
        this._rootElement = v;
        this.structureEditor.setRoot(v);
    } public get rootElement(): FormBuilderElement { return this._rootElement; } private _rootElement: FormBuilderElement;
    public set selectedElement(v: FormBuilderElement) {
        this._selectedElement = v;
        this.propertiesPanel.element = v;
    } public get selectedElement(): FormBuilderElement { return this._selectedElement; } private _selectedElement: FormBuilderElement;



    public set dataModel(v: DataModel) { this._dataModel = v; } public get dataModel(): DataModel { return this._dataModel; } private _dataModel: DataModel;
    public set dataModelClass(v: DataModelClass) { this._dataModelClass = v; } public get dataModelClass(): DataModelClass { return this._dataModelClass; } private _dataModelClass: DataModelClass;
    public set viewModelObject(v: CompiledClass) { this._viewModelObject = v; } public get viewModelObject(): CompiledClass { return this._viewModelObject; } private _viewModelObject: CompiledClass;
    public set _Builder_TemplateSelector__(v: ITemplateSelector) { this.__Builder_TemplateSelector__ = v; } public get _Builder_TemplateSelector__(): ITemplateSelector { return this.__Builder_TemplateSelector__; } private __Builder_TemplateSelector__: ITemplateSelector;
    public set currentPart(v: ViewModel) { this._currentPart = v; } public get currentPart(): ViewModel { return this._currentPart; } private _currentPart: ViewModel;
    public set structureEditor(v: structureEditor) { this._structureEditor = v; } public get structureEditor(): structureEditor { return this._structureEditor; } private _structureEditor: structureEditor;
    
    hasUnsavedChanges():boolean{
        if(this.rootElement==null)
            return false;
        var newJson = new customSerializer().serialize(this.rootElement);
        var oldJson = this.template.jsonInfo;
        return JSON.stringify(newJson)!=JSON.stringify(oldJson);
    }
    private template: TemplateViewModel;
    confirm() {
        try {
            this.template.jsonInfo = new customSerializer().serialize(this.rootElement);
            let html = new HtmlSerializer().serialize(this.rootElement);
            this.template.updateTemplateHtml(html);
            if (this.editResolveFunction) {
                this.editResolveFunction(true);
                this.editResolveFunction = null;
            }
            this.handleMessage(new UnsavedChangesAreCreatedMessage());
            this.messageBoxConfirmSuccess("Saving done Successfully.", "Saving done");
        }
        catch {
            this.messageBoxConfirmWarning("Error saving data.", "Error saving data");
        }
    }
    private editResolveFunction;
    rejectChanges() {
        if(this.editResolveFunction){
            this.editResolveFunction(false);
            this.editResolveFunction = null;
        }
    }
    
    edit(template: TemplateViewModel, dataContext: CompiledClass, mediaType: MediaTypes): Promise<boolean> {
        if (this.editResolveFunction) {
            this.editResolveFunction(false);
            this.editResolveFunction = null;
        }
        this.template = template;
        this.dataModelClass = template.dataModelClass;
        this.viewModelObject = dataContext != null ? dataContext : template.dataModelClass.createInstance(this);
        
        if (template.jsonInfo != null) {
            let element = new customDeserializer().deserialize(this, template.jsonInfo, this.viewModelObject);
            this.rootElement = element;
        } else {
            this.rootElement = new DummyPlaceHolderComponent(this).Create(this);
            this.rootElement.DataContext = this.viewModelObject;
        }
        let result = new Promise<boolean>((res, rej) => {
            this.editResolveFunction = res;
        });
        return result;
    }

    handleMessage(message: ViewModelMessage): any {
        if (message instanceof FormBuilderElementSelectedMessage) {
            if (this.selectedElement) {
                this.selectedElement.self.handleMessage(new FormBuilderElementUnSelectMessage(this.selectedElement));
            }
            this.selectedElement = message.element;
        } else if (message instanceof GetDataModelMessage) {
            return this.dataModelClass.dataModel;
        } else if (message instanceof GetCurrentDataModelClassMessage) {
            return this.dataModelClass;
         } else {
            return super.handleMessage(message);
        }
    }


    selectComponents() {
        this.currentPart = this.componentsList;
    }
    selectProperties() {
        this.currentPart = this.propertiesPanel;
    }
    selectStructure() {
        this.currentPart = this.structureEditor;
    }

    export() {
        let exporter = new ExportViewModel(this);
        exporter.text = JSON.stringify(new customSerializer().serialize(this.rootElement));
        this.requestShowingPopup(exporter);
    }
    async import() {
        let importer = new ImportViewModel(this);
        let result = await this.requestShowingPopup(importer);
        if (stringIsNullOrEmpty(result) == false) {
            let data = JSON.parse(result);
            let element = new customDeserializer().deserialize(this, data, this.viewModelObject);
            this.rootElement = element;
        }
    }

    previewWithTestData() {
        let jsonInfo = new customSerializer().serialize(this.rootElement);
        let html = new HtmlSerializer().serialize(this.rootElement);
        let msg = new PreviewFormBuilderFormMessage();
        msg.currentJsonInfo = jsonInfo;
        msg.currentHtml = html; 
        this.handleMessage(msg);
    }
    
}


export class ComponentsList extends ViewModel {
    public getTypeId(): string { return 'componentslist'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.components = ObservableArray.create<FormBuilderComponent>();
        this.components.push(...new ComponentListStore().listAllComponents(this));
    }

    public set components(v: ObservableArray<FormBuilderComponent>) { this._components = v; } public get components(): ObservableArray<FormBuilderComponent> { return this._components; } private _components: ObservableArray<FormBuilderComponent>;
}

export class ComponentListStore {
    public listAllComponents(parent: ViewModel) {
        let components: FormBuilderComponent[] = []
        components.push(new DummyPlaceHolderComponent(parent));
        components.push(new ClientFilterTableComponent(parent));
        components.push(new ServerFilterTableComponent(parent));
        components.push(new InputComponent(parent));
        components.push(new ContentComponent(parent));
        components.push(new GridComponent(parent));
        components.push(new ComboComponent(parent));
        components.push(new SpanComponent(parent));
        components.push(new DummyTablePlaceHolderComponent(parent));
        components.push(new TdComponent(parent));
        components.push(new ButtonComponent(parent));
        components.push(new CheckBoxComponent(parent));
        components.push(new DateSelectorComponent(parent));
        components.push(new HrComponent(parent));
        components.push(new ListComponent(parent));
        components.push(new LoadingComponent(parent));
        components.push(new MultiLineInputComponent(parent));
        components.push(new ScrollComponent(parent));
        components.push(new FilesListComponent(parent));
        components.push(new ImageComponent(parent));
        components.push(new IconComponent(parent));
        components.push(new ExpanderComponent(parent));
        components.push(new BarcodeReaderComponent(parent));
        components.push(new ChartComponent(parent));
        components.push(new GuageComponent(parent));
        return components;
    }

    public getAllContainers(parent: ViewModel) {
        let components: FormBuilderComponent[] = []
        components.push(new GridComponent(parent));
        components.push(new ButtonComponent(parent));
        components.push(new HrComponent(parent));
        components.push(new LoadingComponent(parent));
        components.push(new ScrollComponent(parent));
        return components;
    }
}

export class structureEditor extends ViewModel {
    public getTypeId(): string { return 'structure'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.children = ObservableArray.create<FormBuilderElement>();
    }
    public set children(v: ObservableArray<FormBuilderElement>) { this._children = v; } public get children(): ObservableArray<FormBuilderElement> { return this._children; } private _children: ObservableArray<FormBuilderElement>;

    setRoot(root: FormBuilderElement) {
        if (root) {
            this.children.update(...[root]);
        } else {
            this.children.clear();
        }

    }
}
export class GetDataModelMessage extends ViewModelMessage {

}

export class GetCurrentDataModelClassMessage extends ViewModelMessage {

}